<template>
  <div style="width: 40%;height: 100px;text-align: center;" :style="{
      '--radio-button-color': $store.getters.getRadioButtonColor,
      '--star-svg-height': `${starHeight}px`
      }">
    <ul class="rating-card__list">
      <li class="rating-card__list__item" v-bind:class="{'-select': model.crowded}"
          v-for="(model, index) in question.answers"
          v-on:click="selectStar(model, index)" v-bind:key="index">
        <label>
          <svg v-bind:class="{'bounce': model.bounced}" class="star-ico"  xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
               viewBox="0 0 576 512" style="enable-background:new 0 0 576 512;" xml:space="preserve">
            <path class="st0" d="M517.8,117.1c2.6,0.3,5.3,0.6,7.9,1c-0.6-6.3-2.9-10-4.8-12.2c-2.9-3.2-4.7-4.5-13.2-9.9
	c-6.2-4-7.3-9.5-6.2-16.2c4.2-26,0.4-50.7-13.5-73.4c-0.9-1.5-3.2-3.4-4.7-3.2c-7.4,0.7-14.8,2.1-23.5,3.4
	c14.6,13.4,18.6,29.6,19.9,46.7c1,13.5-1.7,18.4-14.4,23.1c-10.3,3.8-21.1,6.2-31.8,9c-12.2,3.2-18.4,4.6-23.1,7
	c-2.7,1.4-5,3-7.2,4.7c-11.4,5.3-18.1,17.2-18.3,34.3c-0.1,9.8,1.2,19.6,1.7,29.5c2.1,42.2-6.4,81.1-33.9,114.6
	c-5.1,6.2-9.4,13.2-14,19.8c-82.9,101.9-136.3,127.1-170.4,130.2c-39.5,3.5-73.2,34.4-112.6,38.2c-2.1,0.2-5.7,3.2-5.5,4.2
	c0.5,2.9,2.1,6.5,4.4,7.9c23.7,14.3,48.5,27,76.1,31.3c15.9,2.5,32.4,1.8,48.6,1.4c8-0.2,15.9-2.7,23.8-4.3
	c8.8-1.8,17.7-3.7,26.5-5.7c9.1-2.1,17.4-7.2,27.7-4.5c6.9,1.8,12.4-2.2,15.7-8.8c0.9-1.9,3-4.5,4.6-4.5c9-0.1,16.8-2.8,22.9-9.4
	c8.3,8.5,14.9,8.7,19.9,0.3c7.7-12.7,18.3-20.7,32.2-26.1c30.3-11.8,53.9-31.9,69.6-60.8c4.4-8.2,9.3-16.3,14.3-24.2
	c1.1-1.8,3.4-3.8,5.2-3.9c11.3-0.8,16.6-8,18.7-17.9c2.4-11.3,4.4-22.6,5.9-34c1.1-8,4.2-13.7,11.7-17.5
	c9.1-4.7,16.4-11.6,20.6-21.4c4.2-9.9,8.4-19.9,13.1-29.6c6-12.4,8.2-25.4,8.3-39.1c0.1-6.1,0.8-12.6,2.8-18.3
	c2-5.5,2.1-7.6,2.5-11.4c0.8-7.2-0.7-13.4-2.4-18C521.2,138.5,519.5,127.8,517.8,117.1z"/>
</svg>
          <div style="font-weight:200">{{ model.title }}&nbsp;&nbsp;</div>
        </label>
      </li>
    </ul>


    <label v-for="model in question.answers" v-bind:key="model.uid">
      <input style="display:none;" type="radio"
             v-bind:id="'star'+ model.uid"
             v-on:click="setRadio(model.uid)"
             :value="model.uid"
             :name="question.uid"
             :checked="model.selected"
      />
    </label>

    <transition name="fade">
      <comment v-show="showComment" :placeholder="commentPlaceholder" :name="commentName"></comment>
    </transition>
    <input type="hidden" class="answerSelected" data-question="question.uid" v-model="answerSelected">
  </div>
</template>

<script>
import Vue from 'vue';
import Comment from './Comment';
import Star from 'vue-rate-it/glyphs/star';


export default {
  name: 'pepper',
  props: ['question'],
  data() {
    return {
      answerSelected: false,
      showComment: false,
      commentPlaceholder: false,
      commentName: false,
      radioButtonCheckedPath: false,
      radioButtonUncheckedPath: false,
      thumbsUp: '',
      starHeight: 40,
      stars: [{
        value: 1,
        text: '',
        gradientFrom: '#FC8885',
        gradientTo: '#FB7C7F',
        selected: false,
      },
        {
          value: 2,
          text: '',
          gradientFrom: '#FB7A7E',
          gradientTo: '#F96A74',
          selected: false,
        },
        {
          value: 4,
          text: '',
          gradientFrom: '#F8636F',
          gradientTo: '#F75062',
          selected: false,
        },
        {
          value: 5,
          text: '',
          gradientFrom: '#F75165',
          gradientTo: '#F6415A',
          selected: false,
        }
      ]
    }
  },
  created() {
    // register the icon
    this.star = Star
  },
  mounted() {
    this.radioButtonCheckedPath = this.$store.getters.getRadioButtonCheckedPath;
    this.radioButtonUncheckedPath = this.$store.getters.getRadioButtonUnCheckedPath;
  },
  methods: {
    setRadio: function (uid) {
      this.showComment = false;
      this.commentPlaceholder = false;
      this.commentName = false;

      this.$emit("inputClick", uid);

      this.question.answers.forEach((item, index) => {
        if (item.uid === uid) {
          item.selected = true;
          if (item.is_allow_comment) {
            this.showComment = true;
            this.commentPlaceholder = item.comment_placeholder;
            this.commentName = 'comment_' + this.question.uid;
          }
          Vue.set(this.question.answers, index, item);
        } else {
          item.selected = false;
          Vue.set(this.question.answers, index, item);
        }

        this.$emit("checkDependency", uid);
      });
    },
    onRatingSelected(e) {
      this.setRadio(e);
    },
    resetStars() {
      this.question.answers.forEach(model => model.crowded = false)
    },
    selectStar(model, index) {
      console.log('select');
      this.resetStars()
      let i = 0;
      this.setRadio(model.uid);
      const f = () => {
        if (i <= index) {
          this.question.answers[i].crowded = true;
          i++;
          setTimeout(f, 100)
        }
        model.bounced = true;
      }
      model.bounced = false;
      setTimeout(f, 100)
    },
  },
  components: {
    Comment
  }
}
</script>

<style>

:root {
  --star-svg-height: '100px'
}

@keyframes bounce {
  0% {
    width: 42px;
    height: 66px;
  }
  25% {
    width: 44px;
    height: 68px;
  }
  50% {
    width: 46px;
    height: 69px;
  }
  100% {
    width: 48px;
    height: 70px;
  }
}

.bounce {
  animation-name: bounce;
  animation-duration: 0.2s;
}
</style>
<style lang="scss">
.rating-card__list {
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  justify-content: space-between;
  flex-basis: auto;

  &__item {
    flex-basis: 25%;
    flex-grow: 1;
    font-size: 12px;
    padding-left: 10px;

    .-checked & {
      font-weight: 200;
    }

    input {
      display: none;
    }

    input:checked + label {
      font-weight: 500;
    }

    svg {
      width: var(--star-svg-height);
      height: 54px;

      &:hover {
        cursor: pointer;
      }

      path {
        fill: #e6e7ea;
      }
    }

    &.-select {
      svg {
        path {
          fill: var(--radio-button-color)
        }
      }
    }
  }
}
</style>
